const config = {
  // endpoint: `http://localhost:3001/v1`,
  
  // vercel deployed backend
  endpoint: `https://crm-admin-main-s726.vercel.app/v1`

};

export default config;
